export default "__VITE_ASSET__b0877e72__"